/**
 * 检查值是否为无效内容（null、undefined、NaN、空字符串或只包含空格的字符串）
 * @param value - 要检查的值
 * @returns 如果值无效返回 true，否则返回 false
 * @example
 * ```ts
 * isInvalid(null); // => true
 * isInvalid(undefined); // => true
 * isInvalid(NaN); // => true
 * isInvalid(''); // => true
 * isInvalid('   '); // => true
 * isInvalid(0); // => false
 * isInvalid(false); // => false
 * isInvalid('text'); // => false
 * isInvalid([]); // => false
 * isInvalid({}); // => false
 * ```
 */
export function isInvalid(value: unknown): boolean {
  // 检查 null 和 undefined
  if (value === null || value === undefined) {
    return true;
  }

  // 检查 NaN
  if (typeof value === "number" && isNaN(value)) {
    return true;
  }

  // 检查空字符串或只包含空格的字符串
  if (typeof value === "string" && value.trim() === "") {
    return true;
  }

  // 检查 '--' 字符串
  if (value === "--") {
    return true;
  }

  return false;
}
